<template>
	<div class="drawer">
		<el-drawer
		v-if="detail._id"
		size="420px"
		title="活动详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		style="display: flex;">
			<div class="page">
				<div class="pageLeft">
					<el-row class="row">
						<el-col :span="12">
							<span class="label">活动名称：</span>
							<span class="value">{{curItem.name}}</span>
						</el-col>
						<el-col :span="12">
							<span class="label">活动类型：</span>
							<span class="value">
								<span v-if="curItem.activity_type == 1">充值</span>
								<span v-if="curItem.activity_type == 2">消费</span>
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">活动权重：</span>
							<span class="value">
								<span v-if="curItem.auto_matching == 0">无</span>
								<span v-if="curItem.auto_matching == 1">一级</span>
								<span v-if="curItem.auto_matching == 2">二级</span>
								<span v-if="curItem.auto_matching == 3">三级</span>
								<span v-if="curItem.auto_matching == 4">四级</span>
								<span v-if="curItem.auto_matching == 5">五级</span>
							</span>
						</el-col>
						<el-col :span="12">
							<span class="label">顾客类型：</span>
							<span class="value">
								<span v-if="curItem.activity_user == 0">全部</span>
								<span v-if="curItem.activity_user == 1">普通会员</span>
								<span v-if="curItem.activity_user == 2">充值会员</span>
								<span v-if="curItem.activity_user == 3">散客</span>
								<span v-if="curItem.activity_user == 4">员工</span>
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">员工：</span>
							<span class="value">
								<span v-for="(item,index) in StrOrArr(curItem.staff_type)" :key="index">
									<span v-if="item == 1">在职员工</span> <span v-if="item == 2">离职员工</span>
								</span>
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">新人专享：</span>
							<span class="value">
								<span v-if="curItem.new_member == 1">是</span>
								<span v-if="curItem.new_member == 2">否</span>
							</span>
						</el-col>
						<el-col :span="12">
							<span class="label">参与次数：</span>
							<span class="value">
								{{curItem.use_count}}次
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">活动地点：</span>
							<span class="value">
								线下
							</span>
						</el-col>
						<el-col :span="12">
							<span class="label">活动说明：</span>
							<span class="value">
								{{curItem.remark}}
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="24">
							<span class="label">适用门店：</span>
							<span class="value">
								<span v-for="(item,index) in curItem.company_Info" :key="index">
									<span style="margin-right: 10px;">{{$public.getShopNameById(item.shop_id)}}</span>
								</span>
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="24">
							<span class="label">活动时间：</span>
							<span class="value">
								<span>{{createTimeFormat(curItem.start_time)}}</span> ~ 
								<span>{{createTimeFormat(curItem.exprice_time)}}</span>
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">支付方式：</span>
							<span class="value">
								<span v-for="(item,index) in StrOrArr(curItem.pay_type)" :key="index">
									<span v-if="item == 7">余额</span> <span v-if="item == -1">非余额</span>
								</span>
							</span>
						</el-col>
						<el-col :span="12" v-if="curItem.consume_item">
							<span class="label">活动类型：</span>
							<span class="value">
								<span v-if="curItem.consume_item.consume_type == 1">满{{curItem.consume_item.full_reduction.full_reduction_conditions}}元减{{curItem.consume_item.full_reduction.full_reduction_value}}元</span>
								<span v-if="curItem.consume_item.consume_type == 2 && curItem.consume_item.full_give.full_give_type == 1">满{{curItem.consume_item.full_give.full_give_conditions}}元赠(指定商品)</span>
								<span v-if="curItem.consume_item.consume_type == 2 && curItem.consume_item.full_give.full_give_type == 2">满{{curItem.consume_item.full_give.full_give_conditions}}个赠(指定商品)</span>
								<span v-if="curItem.consume_item.consume_type == 3">折扣:{{curItem.consume_item.other_info.other_info_value}}折</span>
								<span v-if="curItem.consume_item.consume_type == 4">立减:{{curItem.consume_item.other_info.other_info_value}}元</span>
								<span v-if="curItem.consume_item.consume_type == 5">特价:{{curItem.consume_item.other_info.other_info_value}}元</span>
							</span>
						</el-col>
					</el-row>
				</div>
				<div class="pageRight">
					<!-- 产品信息 -->
					<div class="shopView" v-if="curItem.activity_type == 2" style="margin-bottom: 20px;">
						<div class="titleView">
							<div class="line"></div>
							<div class="titleName">产品信息</div>
						</div>
						<el-row style="line-height: 40px;color: #FF182A;font-size: 12px;padding-left:20px;">
							<el-col v-if="curItem.consume_item.type == 0">全部商品</el-col>
							<el-col v-if="curItem.consume_item.type == 1">品牌:</el-col>
							<el-col v-if="curItem.consume_item.type == 2">商品类目:</el-col>
							<el-col v-if="curItem.consume_item.type == 3">指定商品:</el-col>
							<el-col v-if="curItem.consume_item.type == 4">指定条码:</el-col>
						</el-row>
						<!-- 选择类目 -->
						<div class="com" v-if="curItem.consume_item.type == 2">
							<div class="comView">
								<div class="comItem" v-for="(item,index) in curItem.consume_item.param" :key="index">
									<el-tag
									type="warning"
									style="margin-bottom:5px;"
									:disable-transitions="false"
									size="small">
										{{item.name}}
									</el-tag>
								</div>
							</div>
						</div>
						<!-- 选择品牌 -->
						<div class="com" v-if="curItem.consume_item.type == 1">
							<div class="comView">
								<div class="comItem" v-for="(item,index) in curItem.consume_item.param" :key="index">
									<el-tag
									type="warning"
									style="margin-bottom:5px;"
									:disable-transitions="false"
									size="small">
										{{item.name}}
									</el-tag>
								</div>
							</div>
						</div>
						<!-- 选择商品 -->
						<div v-if="curItem.consume_item.type == 3">
							<el-table :data="curItem.consume_item.param" border style="width: 100%">
								<el-table-column fixed prop="param_type_name" label="类目" align="center">
								</el-table-column>
								<el-table-column prop="name" label="名称" align="center">
								</el-table-column>
								<el-table-column label="规格" align="center">
									<template slot-scope="scope">
										<div>{{scope.row.param_sku_name == ''?'--':FSkuNames(scope.row)}}</div>
									</template>
								</el-table-column>
								<el-table-column label="包装单位" align="center">
									<template slot-scope="scope">
										<div>{{scope.row.param_packing_way_name == ''?'--':scope.row.param_packing_way_name}}</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<!-- 指定条码 -->
						<div v-if="curItem.consume_item.type== 4" class="com">
							<div class="comView">
								<div class="comItem" v-for="(item,index) in curItem.consume_item.param" :key="index">
									<el-tag
									type="warning"
									style="margin-bottom:5px;"
									:disable-transitions="false"
									size="small">
										{{item.param_custom_code}} {{item.name}}
									</el-tag>
								</div>
							</div>
						</div>
					</div>
					<!-- 赠品信息 -->
					<div class="giveView" v-if="curItem.activity_type == 1 || curItem.consume_item.consume_type == 2">
						<div class="titleView">
							<div class="line"></div>
							<div class="titleName">赠品信息</div>
						</div>
						<el-row style="line-height: 40px;color: #FF182A;font-size: 12px;padding-left:20px;">
							<el-col v-if="curItem.give_goods.give_type == 1">{{curItem.give_goods.give_list.length}}选{{curItem.give_goods.give_count}}</el-col>
							<el-col v-if="curItem.give_goods.give_type == 2">可领取赠品</el-col>
							<el-col v-if="curItem.give_goods.give_type == 3">活体{{curItem.give_goods.give_living_list.length}}选1</el-col>
						</el-row>
						<el-table :data="curItem.give_goods.give_list" border style="width: 100%" v-if="curItem.give_goods.give_type == 1 || curItem.give_goods.give_type == 2">
							<el-table-column fixed prop="param_type_name" label="类目" align="center">
							</el-table-column>
							<el-table-column prop="goods_name" label="名称" align="center">
							</el-table-column>
							<el-table-column label="规格" align="center">
								<template slot-scope="scope">
									<div>{{scope.row.sku_value == ''?'--':scope.row.sku_value}}</div>
								</template>
							</el-table-column>
							<el-table-column label="包装单位" align="center">
								<template slot-scope="scope">
									<div>{{scope.row.packing_way_name == ''?'--':scope.row.packing_way_name}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="province" label="指定数量" align="center" :key='8' width="142" v-if="curItem.give_goods.giveType == 2">
								<template slot-scope="scope">
									<span style="width:120px">{{scope.row.goods_count}}</span>
								</template>
							</el-table-column>
						</el-table>
						<el-table :data="curItem.give_goods.give_living_list" border v-if="curItem.give_goods.give_type == 3">
							<el-table-column label="昵称" prop="inside_name" align="center"></el-table-column>
							<el-table-column label="品种" prop="category_name" align="center"></el-table-column>
							<el-table-column label="芯片编号" prop="eprom_no" align="center"></el-table-column>
							<el-table-column label="脖圈号" prop="inside_no" align="center"></el-table-column>
						</el-table>
					</div>
					
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus: false,
				curTabIndex: 0,
				detail: {},
			}
		},
		computed: {
			curShopId() {
				return this.$store.state.shopId;
			},
		},
		props: {
			curItem: {
				default: () => {
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.drawerStatus = true;
				this.detail = this.curItem
			})
			console.log('活动详情', this.curItem)
		},
		methods: {
			//格式化规格
			FSkuNames(str){
				// console.log(str)
				if(str.param_type_id == 0){
					let s = ''
					let arr = str.param_sku_name.split(',')
					for(let i=0;i<arr.length;i++){
						s+=arr[i].split(":")[1]+'，'
					}
					return s.substr(0,s.length-1);
				}else{
					return str.param_sku_name
				}
			},
			//格式化采购日期
			createTimeFormat(row) {
				let date = row * 1000;
				let moment = require("moment");
				return moment(date).format("YYYY-MM-DD HH:mm:ss");
			},
			//字符串转数组
			StrOrArr(str){
				return str.split(',')
			},
			handleClose() {
				this.$emit('submit', {
					type: 'close'
				})
			},
			// 改变tab
			changeTab(index) {
				this.curTabIndex = index;
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer {
		width: 0;
		padding: 0 0 0 0;
		::v-deep.el-drawer {
			.label {
				display: inline-block;
				width: 150px;
				text-align: right;
			}
			.el-drawer__body{
				height: 100%;
				overflow-y: auto;
			}
		}
		.page{
			// 活动详情左侧
			.pageLeft {
				.row{
					padding:14px 5px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;border-bottom:1px solid #F2F2F2;
					.label{
						display: inline-block;width:70px;text-align: right;
					}
				}
			}
			// 活动详情右侧
			.pageRight{
				padding: 20px 0;
				display: flex;
				flex-direction: column;
				.comView {
					// width: 800px;
					min-height: 120px;
					border: 1px solid rgba(0, 0, 0, 0.15);
					border-radius: 2px;
					padding: 10px 10px 0 10px;
				
					.comItem {
						margin-right: 6px;
						margin-bottom: 10px;
						display: flex;
						align-items: center;
						line-height: 22px;
						font-size: 12px;
						display: inline-block;
						border-radius: 2px;
					}
				}
			}
			.l50{
				line-height: 50px;
			}
			.ar{
				text-align: right;
				color: #2a2a2a;
			}
			.leftItem{
				color: #6C6C6C;
				padding-left: 10px;
			}
			//头部信息
			.titleView {
				display: flex;
				align-items: center;
				padding-bottom: 16px;
				border-bottom: solid 1px #F5F5F5;
				padding-left: 5px;
				.line {
					width: 2px;
					height: 15px;
					background: $mainColor;
					margin-right: 5px;
				}
				.titleName {
					font-size: 14px;
					color: $fontColor;
				}
			}
		}
		
	}
</style>
